import React from 'react';
type BoxVariant = 'highlight' | 'problem' | 'solution' | 'testimonial' | 'science';
interface InfoBoxProps {
  variant: BoxVariant;
  children: React.ReactNode;
  className?: string;
}
export function InfoBox({
  variant,
  children,
  className = ''
}: InfoBoxProps) {
  const styles = {
    highlight: {
      container: 'bg-gradient-to-br from-[#ffeaa7] to-[#fdcb6e] border-l-[5px] border-[#f39c12] text-[#2c3e50]',
      text: 'font-medium'
    },
    problem: {
      container: 'bg-gradient-to-br from-[#fab1a0] to-[#ff7675] border-l-[5px] border-[#d63031] text-white',
      text: 'text-white'
    },
    solution: {
      container: 'bg-gradient-to-br from-[#a29bfe] to-[#6c5ce7] border-l-[5px] border-[#5f27cd] text-white',
      text: 'text-white'
    },
    testimonial: {
      container: 'bg-[#f8f9fa] border-l-[5px] border-[#00b894] text-[#2c3e50]',
      text: 'italic text-lg'
    },
    science: {
      container: 'bg-[#e8f5e9] border-l-[4px] border-[#4caf50] text-[#2c3e50]',
      text: ''
    }
  };
  const currentStyle = styles[variant];
  return <div className={`p-8 my-8 rounded-lg shadow-sm ${currentStyle.container} ${className}`} data-id="element-8">
      <div className={currentStyle.text} data-id="element-9">{children}</div>
    </div>;
}